import React from 'react';
import classNames from 'classnames';

import { IWithSettingsProps, withSettings } from '../../context/settings';

import { ButtonStyle } from '@wix/podcasts-common/dist/settings';
import { ButtonSize } from './types';

import styles from './Button.scss';

interface IButtonProps extends IWithSettingsProps {
  children: any;
  icon?: React.ReactElement<{ className: string }>;
  size?: ButtonSize;
  className?: string;
  type?: 'button' | 'reset' | 'submit';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

function Button({
  size = ButtonSize.MEDIUM,
  icon,
  settings,
  children,
  className,
  type,
  onClick,
  disabled,
}: IButtonProps) {
  const buttonStyle = settings.common.buttonStyle;

  icon = icon && React.cloneElement(icon, { className: styles.buttonIcon });

  return (
    <button
      className={classNames(styles.button, className, {
        [styles.buttonRound]:
          buttonStyle === ButtonStyle.ROUND_FULL ||
          buttonStyle === ButtonStyle.ROUND_OUTLINE,
        [styles.buttonOutline]:
          buttonStyle === ButtonStyle.ROUND_OUTLINE ||
          buttonStyle === ButtonStyle.SQUARE_OUTLINE,
        [styles.buttonSmall]: size === ButtonSize.SMALL,
      })}
      disabled={disabled}
      type={type || 'button'}
      onClick={onClick}
    >
      {icon}
      {children}
    </button>
  );
}

export default withSettings(Button);
